module.exports = __webpack_public_path__ + "static/sport/game-3.0381578.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sport6/game-3.png
// module id = 68DE
// module chunks = 0